import { render } from "./MembersCards.vue?vue&type=template&id=2076c5de"
import script from "./MembersCards.vue?vue&type=script&lang=js"
export * from "./MembersCards.vue?vue&type=script&lang=js"

import "./MembersCards.vue?vue&type=style&index=0&id=2076c5de&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__